import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Location\GetLocationListController::__invoke
* @see app/Http/Controllers/Location/GetLocationListController.php
* @route '/api/location'
*/
const GetLocationListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLocationListController.url(options),
    method: 'get',
})

GetLocationListController.definition = {
    methods: ["get","head"],
    url: '/api/location',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Location\GetLocationListController::__invoke
* @see app/Http/Controllers/Location/GetLocationListController.php
* @route '/api/location'
*/
GetLocationListController.url = (options?: RouteQueryOptions) => {
    return GetLocationListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Location\GetLocationListController::__invoke
* @see app/Http/Controllers/Location/GetLocationListController.php
* @route '/api/location'
*/
GetLocationListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLocationListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Location\GetLocationListController::__invoke
* @see app/Http/Controllers/Location/GetLocationListController.php
* @route '/api/location'
*/
GetLocationListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetLocationListController.url(options),
    method: 'head',
})

export default GetLocationListController